import colors from "assets/theme/base/colors";

const { white } = colors;

const card = {
  styleOverrides: {
    root: {
      display: "flex",
      flexDirection: "column",
      position: "relative",
      minWidth: 0,
      wordWrap: "break-word",
      backgroundColor: white.main,
      backgroundClip: "border-box",
      border: "1px solid #E2E8F0",
      borderRadius: 18,
      boxShadow: "0 8px 30px rgba(15, 23, 42, 0.055)",
      transition: "box-shadow .2s ease, border-color .2s ease",
    },
  },
};

export default card;
